
import LiveVisitors, { live_visitors } from './live_visitors'

export { LiveVisitors, live_visitors }
export default LiveVisitors


// WEBPACK FOOTER //
// ./src/components/visitors/index.js